import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = [{
  q: '¿Cuánto cuesta el Sistema A.C.E.™?',
  a: 'Cada plan se personaliza según tu zona y competencia. En la auditoría gratuita te damos un presupuesto exacto. Lo que sí te garantizamos: el retorno supera la inversión en el primer mes o te devolvemos el dinero.'
}, {
  q: '¿En cuánto tiempo veo resultados?',
  a: "Los primeros leads llegan en 72 horas después de activar el sistema. En 2-3 semanas ya tienes un flujo constante. No somos de los que te dicen 'espera 3 meses'."
}, {
  q: '¿Qué pasa si ya tengo una agencia de marketing?',
  a: 'Si tu agencia actual te está dando resultados, genial. Si estás aquí leyendo esto, probablemente no. Nuestro sistema puede complementar o reemplazar lo que tienes. En la auditoría te decimos exactamente qué está fallando.'
}, {
  q: '¿Trabajan con empresas de Roofing en mi área?',
  a: 'Sí. Trabajamos con empresas de Roofing en todo Estados Unidos. En la auditoría gratuita analizamos tu zona, tu competencia y diseñamos una estrategia personalizada para tu mercado.'
}, {
  q: '¿Necesito un website o redes sociales?',
  a: 'No. Nosotros construimos todo desde cero: Landing Page, sistema de respuesta automática, y campañas. Solo necesitas saber hacer techos. Del resto nos encargamos nosotros.'
}, {
  q: '¿Hay contrato a largo plazo?',
  a: 'No. Trabajamos mes a mes. Si no estás satisfecho, cancelas cuando quieras. Pero spoiler: nadie cancela cuando su teléfono no para de sonar.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-16 md:py-24 px-4 bg-carbon border-t border-dark-border" data-id="element-152">
      <div className="max-w-3xl mx-auto" data-id="element-153">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-2xl md:text-4xl font-heading font-bold text-gold text-center mb-10 md:mb-16" data-id="element-154">
          Preguntas Frecuentes
        </motion.h2>

        <div className="space-y-4" data-id="element-155">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="border-b border-[#151515] overflow-hidden" data-id="element-156">
                <button onClick={() => toggleFAQ(index)} className="w-full py-5 flex justify-between items-center text-left focus:outline-none" data-id="element-157">
                  <span className="text-white font-bold text-base md:text-lg pr-4" data-id="element-158">
                    {faq.q}
                  </span>
                  <motion.svg animate={{
                rotate: isOpen ? 180 : 0
              }} transition={{
                duration: 0.3
              }} className="w-5 h-5 text-gold shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-159">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" data-id="element-160" />
                  </motion.svg>
                </button>
                <AnimatePresence data-id="element-161">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-162">
                      <p className="pb-5 text-gray-sec text-sm md:text-base leading-relaxed" data-id="element-163">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}